import { defineComponent as _defineComponent } from 'vue'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const __default__ = require('@nuxtjs/composition-api').defineComponent({
  head() {
    // Don't reinitialise the script if it's already loaded
    if (process.browser && window.google) {
      // @ts-ignore
      this.initAutocomplete();
      return {};
    }
    return {
      script: [
        {
          vmid: 'google-maps',
          hid: 'google-maps-js',
          src: `https://maps.googleapis.com/maps/api/js?key=${this.$config.placesApiKey}&libraries=places`,
          async: true,
          // @ts-ignore
          callback: () => this.initAutocomplete(),
        },
      ],
    };
  },
});

import { useContext, watch, ref } from '@nuxtjs/composition-api';
import Vue from 'vue';
import CountrySelect from '~/components/CountrySelect.vue';
import { usePlacesAutocomplete, Address } from '~/composables/usePlacesAutocomplete';
import TLabel from '~/components/atoms/t-label.vue';
import TInput from '~/components/atoms/t-input.vue';

interface Emits {
  (event: 'update:address', address: Address): void;
}
interface Props {
  initialAddress?: Address;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'BillingAddressForm',
  props: {
    initialAddress: null
  },
  emits: ["update:address"],
  setup(__props: any, { expose, emit }: { emit: ({
  (event: 'update:address', address: Address): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  initialAddress?: Address;
};



const { i18n } = useContext();
const search = ref<typeof TInput | null>(null);
const { init, addressFull, city, country, state, postcode } = usePlacesAutocomplete(
  props.initialAddress
);

watch([addressFull, city, country, state, country, postcode], () => {
  emit('update:address', {
    address1: addressFull.value,
    city: city.value,
    country: country.value,
    state: state.value,
    postcode: postcode.value,
  });
});

// There seems to be a race condition between the state update and
// the google places autocomplete library updating the element so the element is out of sync.
// This is a bit hacky but seems to fix the problem.
watch(addressFull, () => {
  if (search.value) {
    search.value.$el.value = addressFull.value;
  }
});

const preventEnterKeyFromSubmittingForm = (element: HTMLElement) => {
  element.addEventListener('keydown', function (e: KeyboardEvent) {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  });
};

const initAutocomplete = () => {
  // we wait for the component to be mounted before init the autocomplete
  Vue.nextTick(() => {
    if (search.value?.$el) {
      init(i18n.locale, search.value.$el);
      preventEnterKeyFromSubmittingForm(search.value.$el);
    }
  });
};

expose({
  initAutocomplete,
});

return { __sfc: true,props, emit, i18n, search, init, addressFull, city, country, state, postcode, preventEnterKeyFromSubmittingForm, initAutocomplete, CountrySelect, TLabel, TInput }
}

})